export const APP_BG = "#101010"
export const APP_BG_2 = "#363636"
export const COL_WHITE = "#FFFFFF"
export const COL_OFF_WHITE = "#A7A8A8"
export const COL_BLACK = "#000000"
export const COL_PRIMARY = "#EF4B4B"
export const COL_PRIMARY_BG = "#EF4B4B15"
export const COL_INFO = "#FFC108"
export const COL_INFO_SUCCESS = "#EEB50C"